import MachinePolicySummary from "./MachinePolicySummary";

export default MachinePolicySummary;
